import React, { memo, useEffect } from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { WARNING_MESSAGE_SHOW } from '../../../../constants/biEvents';
import { useReporting } from '../../../../context/contexts/reporting';
import { ERROR_TYPE_KEYS } from '../../../../context/validation';
import { selectErrorFlag, selectSubmitted, useValidationContext } from '../../../../context/contexts/validation';
import { useStaticContext } from '../../../../context/contexts/static';
import { calculateValidationMessageKey } from './utils';
import WarningMessage from './WarningMessage';

import classes from './style.module.scss';

const ValidationMessage = () => {
    const { sendBiEvent, sendMixpanelEvent } = useReporting();
    const validationContext = useValidationContext();
    const { isRequestToOrderModal } = useStaticContext();
    const { errors, showErrors, warnings } = selectErrorFlag(validationContext);
    const submitted = selectSubmitted(validationContext);
    const copyKey = isRequestToOrderModal ? 'request_to_order' : 'send_message';
    const hasErrors = !isEmpty(errors);
    const hasWarnings = !isEmpty(warnings);
    const messageKey = calculateValidationMessageKey({
        errors,
        warnings
    });
    const show = (showErrors && hasErrors) || hasWarnings;

    useEffect(() => {
        if (!show) {
            return;
        }

        const event = {
            type: WARNING_MESSAGE_SHOW,
            params: {
                reason: messageKey
            }
        };

        sendBiEvent(event);
        sendMixpanelEvent(event);
    }, [show, messageKey, sendBiEvent, sendMixpanelEvent]);

    if (!show) {
        return null;
    }

    const isError = ERROR_TYPE_KEYS.includes(messageKey);
    const showAsError = isError && submitted;

    const wrapperClasses = classNames(
        classes.validationMessage,
        'm-r-8',
        { [classes.error]: showAsError }
    );

    return (
        <div className={wrapperClasses} data-testid="validation-message">
            {isError ?
                <I18n k={`${copyKey}.validation.${messageKey}`}/> :
                <WarningMessage messageKey={messageKey}/>
            }
        </div>
    );
};

export default memo(ValidationMessage);
